import { render, staticRenderFns } from "./RedirectEditor.vue?vue&type=template&id=672a29f4"
import script from "./RedirectEditor.vue?vue&type=script&lang=js"
export * from "./RedirectEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports